import React from "react";
import { Tooltip } from "@mui/material";
import { PlusIcon } from "../../../../components/Icons";
import { colors } from "../../../../theme/colors";
import {
  ChipsContainer,
  ViewChip,
  TreatmentStepEmptyValue,
  EditAddButton,
  TooltipAnchor,
} from "./TreatmentStepChips.styled";

interface TreatmentStepChipsProps {
  values: string[];
  emptyLabel?: string;
  error?: boolean;
  errorReason?: string;
}

const TreatmentStepChips: React.FC<TreatmentStepChipsProps> = ({
  values,
  emptyLabel = "—",
  error = false,
  errorReason,
}) => {
  if (values.length === 0) {
    if (error) {
      const indicator = (
        <EditAddButton type="button" variant="icon" error disabled={false}>
          <PlusIcon
            width="14px"
            height="14px"
            fill={colors.status.error}
          />
        </EditAddButton>
      );

      return errorReason ? (
        <Tooltip title={errorReason} arrow placement="bottom">
          <TooltipAnchor>{indicator}</TooltipAnchor>
        </Tooltip>
      ) : (
        indicator
      );
    }

    return <TreatmentStepEmptyValue>{emptyLabel}</TreatmentStepEmptyValue>;
  }

  return (
    <ChipsContainer>
      {values.map((value) => (
        <ViewChip key={value}>{value}</ViewChip>
      ))}
    </ChipsContainer>
  );
};

export default TreatmentStepChips;
